var exports = {
  "O3": "xaf9ae18d--81fddb--underground",
  "KM": "xaf9ae18d--81fddb--underground-group",
  "mb": "xaf9ae18d--81fddb--redesign",
  "or": "xaf9ae18d--81fddb--underground-icon",
  "Oz": "xaf9ae18d--81fddb--underground-name",
  "hl": "xaf9ae18d--81fddb--address",
  "G6": "xaf9ae18d--81fddb--distance-group",
  "wJ": "xaf9ae18d--81fddb--distance-icon",
  "KG": "xaf9ae18d--81fddb--distance-time",
  "n": "xaf9ae18d--81fddb--distance-icon--walk",
  "ru": "xaf9ae18d--81fddb--distance-icon--transport",
  "zX": "xaf9ae18d--81fddb--underground-icon--www",
  "ec": "xaf9ae18d--81fddb--underground-icon--ekb",
  "VN": "xaf9ae18d--81fddb--underground-icon--kazan",
  "sO": "xaf9ae18d--81fddb--underground-icon--nn",
  "li": "xaf9ae18d--81fddb--underground-icon--novosibirsk",
  "rz": "xaf9ae18d--81fddb--underground-icon--samara",
  "NU": "xaf9ae18d--81fddb--underground-icon--spb",
};

module.exports = exports;
